export default {
  authorityGroupsResults(currentState, value) {
    const state = currentState;
    state.authorityGroupsResults = Object.assign([], value);
  },
};
